@if (pageData$()) {
  <div [ngClass]="{'no_data_sec':addCss, 'm-t-20': addmtCss}">
    @if (showPageHeader$()) {
      <app-page-header [pageName]="pageData$()?.pageName"></app-page-header>
    }
    @if (backButtonUrl$()) {
      <a class="back_btn" [routerLink]="[backButtonUrl$()]"><span
      class="material-icons">chevron_left</span>BACK</a>
    }
    <div class="no_data" [ngClass]="{'mt-32':addCss}">
      <div class="nodata_content">{{pageData$()?.heading}}</div>
      <div class="nodata_content_1">{{pageData$()?.description}}</div>
      <div roleAccessControl #buttonAccess="accessControl" [accessType]="accessType"></div>
      @if (pageData$()?.buttonName && (buttonAccess.accessControl && ((pageType == 'forward-generate' && pageDetails?.institutionIds?.length <= 5) || (pageType != 'forward-generate' && !pageType.includes('view_related_course'))))) {
        <button id="createButtonAutomationId"
          class="custom_btn" mat-stroked-button color="primary" (click)="addNewData()">
          <span class="material-icons">add</span>{{pageData$().buttonName}}
        </button>
      }
      @if (pageData$()?.buttonName && (!buttonAccess.accessControl || pageType.includes('view_related_course') || (pageType == 'forward-generate' && pageDetails?.institutionIds?.length > 5))) {
        <button  class="disabled custom_btn" mat-stroked-button color="primary">
          <span class="material-icons">add</span>{{pageData$().buttonName}}
        </button>
      }
    </div>
  </div>
}